import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromApp from "../../../store/app.reducer";
import * as selectors from "../../../store/app.selectors";
import * as _ from "lodash";
import { distinctUntilChanged } from "rxjs/operators";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { AlertController, ToastController } from "@ionic/angular";
import * as AuthActions from "../../../auth/store/auth.actions";
import { LoginPopupsServiceService } from "src/app/services/login-popups-service/login-popups-service.service";
import { AnalyticsServiceService } from "src/app/services/analitycsService/analytics-service.service";
import { Capacitor } from "@capacitor/core";

@Component({
  selector: "app-customer-register-only-dine-in",
  templateUrl: "./customer-register-only-dine-in.component.html",
  styleUrls: ["./customer-register-only-dine-in.component.scss"],
})
export class CustomerRegisterOnlyDineInComponent implements OnInit, OnDestroy {
  public currentUser: any;
  public mo_token: any;
  public loginLoading: any;
  public groupApp: any;
  public loginChoice: string = "order-without-login";
  public storeInfo: any;

  private newCustomer: any;
  private mobileInputAlert: any;
  private errorToast: any;
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<fromApp.AppState>,
    private loginPopupService: LoginPopupsServiceService,
    private alertController: AlertController,
    private translateService: TranslateService,
    private toastController: ToastController,

    private analyticsService: AnalyticsServiceService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.store
        .select(selectors.getStoreInfo)
        .pipe(distinctUntilChanged())
        .subscribe((storeInfo) => {
          if (storeInfo && !_.isEqual(this.storeInfo, storeInfo)) {
            this.storeInfo = _.cloneDeep(storeInfo);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("groupApp")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.groupApp &&
            !_.isEqual(this.groupApp, state.groupApp)
          ) {
            this.groupApp = _.cloneDeep(state.groupApp);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("auth")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(state.user, this.currentUser)) {
            //console.log("user sub triggered");
            this.currentUser = _.cloneDeep(state.user);
          }

          if (state && !_.isEqual(state.newCustomer, this.newCustomer)) {
            this.newCustomer = _.cloneDeep(state.newCustomer);
          }

          if (state && !_.isEqual(state.loginLoading, this.loginLoading)) {
            this.loginLoading = _.cloneDeep(state.loginLoading);
          }
          if (
            state &&
            state.mo_token &&
            !_.isEqual(this.mo_token, state.mo_token)
          ) {
            this.mo_token = _.cloneDeep(state.mo_token);
          }
        })
    );
  }

  public async showMobileInputAlert() {
    this.mobileInputAlert = null;

    this.mobileInputAlert = await this.alertController.create({
      header: this.translateService.instant("homepage.magic-login"),
      cssClass: "maginLoginPopup",
      backdropDismiss: false,
      message: this.translateService.instant(
        "popups.magic-login-popup.please-enter-your-mobile"
      ),
      inputs: [
        {
          name: "mobile",
          type: "tel",
          value: "",
          id: "inputMobile",
          placeholder: this.translateService.instant(
            "popups.magic-login-confirmation.write-here"
          ),
        },
      ],
      buttons: [
        {
          text: this.translateService.instant(
            "popups.magic-login-confirmation.cancel"
          ),
          role: "cancel",
          cssClass: "secondary",
          handler: () => {
            console.log("Confirm Cancel");
            this.loginChoice = "order-without-login";
          },
        },
        {
          text: "OK",
          role: "OK",

          handler: (data) => {
            if (data && data.mobile) {
              let auto_fill_mobile = _.cloneDeep(
                data.mobile.toString().replace(/\s/g, "")
              );

              this.store.dispatch(
                new AuthActions.SetLogoutFlagTimestamp(
                  "do_not_navigate" + Date.now().toString()
                )
              );

              this.analyticsService.dmAnalyticsMessage(
                "login_button",
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
              );
              if (this.groupApp && this.groupApp.active_reservation_app) {
                this.loginPopupService.presentFirebaseModalLogin(
                  null,
                  null,
                  null
                );
              } else {
                if (!Capacitor.isNativePlatform()) {
                  this.loginPopupService.presentFirebaseModalLogin(
                    null,
                    null,
                    auto_fill_mobile
                  );
                } else {
                  this.loginPopupService.presentMobileMagicLoginAlert(
                    this.newCustomer,
                    this.groupApp,
                    auto_fill_mobile
                  );
                }
              }
            } else {
              if (this.errorToast) {
                this.errorToast.dismiss();
                this.errorToast = null;
              }
              this.presentErrorToast(
                this.translateService.instant(
                  "popups.magic-login-popup.please-enter-your-mobile"
                ),
                "danger"
              );
              return false;
            }
          },
        },
      ],
    });

    const inputMobile: any = document.getElementById("inputMobile");
    if (inputMobile) {
      inputMobile.onkeyup = (ev) => {
        if (ev.key === "enter" || ev.keyCode === 13) {
          ev.preventDefault();
          if (inputMobile && inputMobile.value) {
          } else {
            if (this.errorToast) {
              this.errorToast.dismiss();
              this.errorToast = null;
            }
            this.presentErrorToast(
              this.translateService.instant(
                "popups.magic-login-popup.please-enter-your-mobile"
              ),
              "danger"
            );
            return false;
          }
        }
      };
    }

    await this.mobileInputAlert.present();
    this.mobileInputAlert
      .onDidDismiss()
      .then(() => {
        this.mobileInputAlert = null;
      })
      .finally(() => {});
  }

  onLoginChoiceChange(event: any) {
    if (event.detail.value === "magic-login") {
      this.presentMagicLoginPopup();
    }
  }

  async presentErrorToast(message, color) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: "middle",

      color: color,
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",

          handler: () => {
            console.log("Toast Closed");
          },
        },
      ],
    });
    toast.present();
  }

  async presentMagicLoginPopup() {
    // this.MagicLoginservice.presentLoginModal(this.newCustomer);

    await this.showMobileInputAlert();
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
